"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _get = _interopRequireDefault(require("transmute/get"));

var _actions = require("../actions");

var _EditSettingsConfig = _interopRequireDefault(require("../records/EditSettingsConfig"));

var cleanSlug = function cleanSlug(slug) {
  return slug.replace(/[^a-zA-Z\d\s-]/gi, '').replace(/\s+/g, '-').replace(/-+/g, '-').toLowerCase();
};

var initialState = new _EditSettingsConfig.default();

var getDefaultLink = function getDefaultLink(data) {
  return (0, _get.default)('id', data.find(function (link) {
    return link.isDefaultLink;
  }));
};

var updateStagedChanged = function updateStagedChanged(settingsConfig, data) {
  return settingsConfig.set('stagedChanges', settingsConfig.stagedChanges.withMutations(function (map) {
    var namespace = data.namespace,
        calendarIdsToCheck = data.calendarIdsToCheck,
        calendarDisplayNames = data.calendarDisplayNames,
        customHostedDomain = data.customHostedDomain,
        ewsUri = data.ewsUri,
        calendarUsername = data.calendarUsername;
    var customHostedDomainName = customHostedDomain ? customHostedDomain.get('domain') : null;
    map.merge({
      namespace: namespace,
      calendarIdsToCheck: calendarIdsToCheck,
      calendarDisplayNames: calendarDisplayNames,
      customHostedDomainName: customHostedDomainName,
      ewsUri: ewsUri,
      calendarUsername: calendarUsername
    });
  }));
};

var setStagedChanges = function setStagedChanges(settingsConfig, attribute, value) {
  return settingsConfig.set('stagedChanges', settingsConfig.stagedChanges.set(attribute, value));
};

var _default = function _default(getState) {
  var _handleActions;

  return (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchMeetingsUserActionTypes.SUCCESS, function (settingsConfig, action) {
    return updateStagedChanged(settingsConfig, action.payload.data);
  }), (0, _defineProperty2.default)(_handleActions, _actions.FetchLinksActionTypes.SUCCESS, function (settingsConfig, action) {
    var defaultLinkId = getDefaultLink(action.payload.data);
    return setStagedChanges(settingsConfig, 'defaultLinkId', defaultLinkId).set('defaultLinkId', defaultLinkId);
  }), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_actions.SaveMeetingsUserActionTypes.SUCCESS, _actions.UpdateMeetingsUserIntegrationActionTypes.SUCCESS), function (settingsConfig, action) {
    return updateStagedChanged(settingsConfig, action.payload.data).set('namespaceCollision', null);
  }), (0, _defineProperty2.default)(_handleActions, _actions.DisconnectMeetingsUserActionTypes.SUCCESS, function () {
    return initialState;
  }), (0, _defineProperty2.default)(_handleActions, _actions.ValidateNamespaceActionTypes.SUCCESS, function (settingsConfig, action) {
    return settingsConfig.set('namespaceCollision', action.payload.data);
  }), (0, _defineProperty2.default)(_handleActions, _actions.ValidateNamespaceActionTypes.FAILURE, function (settingsConfig) {
    return settingsConfig.set('namespaceCollision', true);
  }), (0, _defineProperty2.default)(_handleActions, _actions.FetchCalendarInfoActionTypes.SUCCESS, function (settingsConfig, action) {
    var calendarDisplayNames = settingsConfig.getIn(['stagedChanges', 'calendarDisplayNames']);
    var updatedCalendarDisplayNames = action.payload.data.reduce(function (acc, calendarInfo) {
      var id = calendarInfo.get('id');
      var displayName = calendarInfo.get('displayName');

      if (calendarDisplayNames.has(id) && calendarDisplayNames.get(id) !== displayName) {
        return acc.set(id, displayName);
      }

      return acc;
    }, calendarDisplayNames);
    return settingsConfig.setIn(['stagedChanges', 'calendarDisplayNames'], updatedCalendarDisplayNames);
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.SET_NAMESPACE_COLLISION_FALSE, function (settingsConfig) {
    return settingsConfig.set('namespaceCollision', false);
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.RESET_EDIT_SETTINGS_CONFIG, function () {
    var meetingsUser = (0, _get.default)('meetingsUser', getState());
    return new _EditSettingsConfig.default().setIn(['stagedChanges', 'namespace'], meetingsUser.get('namespace')).setIn(['stagedChanges', 'defaultLinkId'], meetingsUser.get('defaultLinkId')).setIn(['stagedChanges', 'calendarIdsToCheck'], meetingsUser.get('calendarIdsToCheck')).setIn(['stagedChanges', 'calendarDisplayNames'], meetingsUser.get('calendarDisplayNames')).setIn(['stagedChanges', 'ewsUri'], meetingsUser.get('ewsUri')).setIn(['stagedChanges', 'calendarUsername'], meetingsUser.get('calendarUsername')).setIn(['stagedChanges', 'customHostedDomainName'], meetingsUser.getIn(['customHostedDomain', 'domain']));
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.UPDATE_DEFAULT_LINK, function (settingsConfig, action) {
    return setStagedChanges(settingsConfig, 'defaultLinkId', action.linkId);
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.UPDATE_NAMESPACE, function (settingsConfig, action) {
    return setStagedChanges(settingsConfig, 'namespace', cleanSlug(action.namespace));
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.UPDATE_EXCHANGE_INFO, function (settingsConfig, action) {
    var _action$info = action.info,
        ewsUri = _action$info.ewsUri,
        calendarUsername = _action$info.calendarUsername;
    var updatedUri = setStagedChanges(settingsConfig, 'ewsUri', ewsUri);
    return setStagedChanges(updatedUri, 'calendarUsername', calendarUsername);
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.UPDATE_CALENDAR_INTEGRATION, function (settingsConfig, action) {
    var calendarInfo = (0, _get.default)('calendarInfo', getState());
    var calendarIdsToCheck = settingsConfig.getIn(['stagedChanges', 'calendarIdsToCheck']);
    var calendarDisplayNames = settingsConfig.getIn(['stagedChanges', 'calendarDisplayNames']);

    if (action.value === true) {
      calendarIdsToCheck = calendarIdsToCheck.set(action.id, true);
      calendarDisplayNames = calendarDisplayNames.set(action.id, calendarInfo.find(function (info) {
        return info.id === action.id;
      }).displayName);
    } else {
      calendarIdsToCheck = calendarIdsToCheck.delete(action.id);
      calendarDisplayNames = calendarDisplayNames.delete(action.id);
    }

    return settingsConfig.setIn(['stagedChanges', 'calendarIdsToCheck'], calendarIdsToCheck).setIn(['stagedChanges', 'calendarDisplayNames'], calendarDisplayNames);
  }), (0, _defineProperty2.default)(_handleActions, _actions.MeetingsActionTypes.UPDATE_CUSTOM_HOSTED_DOMAIN_NAME, function (settingsConfig, action) {
    return settingsConfig.setIn(['stagedChanges', 'customHostedDomainName'], action.customHostedDomainName);
  }), (0, _defineProperty2.default)(_handleActions, _actions.FetchPrimaryCalendarActionTypes.SUCCESS, function (settingsConfig, action) {
    var meetingsUser = (0, _get.default)('meetingsUser', getState());
    var email = meetingsUser.get('calendarEmail');
    var primaryCalendarId = action.payload.data.getIn([email, 'id']);
    var calendarIdsToCheck = settingsConfig.getIn(['stagedChanges', 'calendarIdsToCheck']);
    calendarIdsToCheck = calendarIdsToCheck.set(primaryCalendarId, true);
    return settingsConfig.setIn(['stagedChanges', 'calendarIdsToCheck'], calendarIdsToCheck);
  }), _handleActions), initialState);
};

exports.default = _default;
module.exports = exports.default;